import clsx from "clsx";

/**
 * How much of a limit has been used.
 *
 * The React counterpart of js/components/character-counter.js, which does the same job for the
 * server-rendered bio and social link forms. Same warning class, same behaviour: it warns, it does
 * not stop typing. The server counts visible characters and is the only thing that decides whether
 * a value is too long, so a hard cut here would only disagree with it the moment markup is involved.
 */
export function CharacterCount({ value, max, testId }) {
  const used = (value ?? "").length;
  const isOver = used > max;

  return (
    <p
      className={clsx("member-profile-editor__counter", {
        "member-profile-editor__counter--warning": isOver,
      })}
      data-testid={testId}
      aria-live="polite"
    >
      {used} / {max}
    </p>
  );
}
